import { ResourceSet } from 'libs/abc/core/resources/src';
import { gridOptions } from './abc-grid';

export class AbcGridDefaultContextMenu {
  constructor(private res: ResourceSet) {}

  get rmvSort(): string {
    return this.res.get('ContextMenu-RemoveSorts');
  }
  get rmvSortImage(): string {
    return this.res.svgUrl('ContextMenu-RemoveSorts-Image');
  }
  get addcolumn(): string {
    return this.res.get('ContextMenu-AddNewDataColumn');
  }
  get addAIColumn(): string {
    return this.res.get('ContextMenu-AddNewAIDataColumn');
  }
  get addcolumnImage(): string {
    return this.res.svgUrl('ContextMenu-AddNewDataColumn-Image');
  }
  get addAIColumnImage(): string {
    return this.res.svgUrl('ContextMenu-AddNewAIDataColumn-Image');
  }
  get editcolumn(): string {
    return this.res.get('ContextMenu-EditDataColumn');
  }
  get editcolumnImage(): string {
    return this.res.svgUrl('ContextMenu-EditDataColumn-Image');
  }
  get deletecolumn(): string {
    return this.res.get('ContextMenu-DeleteDataColumn');
  }
  get deletecolumnImage(): string {
    return this.res.svgUrl('ContextMenu-DeleteDataColumn-Image');
  }
  get columnselection(): string {
    return this.res.get('ContextMenu-ColumnChooser');
  }
  get columnselectionImage(): string {
    return this.res.svgUrl('ContextMenu-ColumnChooser-Image');
  }
  get objectSets(): string {
    return this.res.get('ContextMenu-ObjectSets');
  }
  get objectSetsImage(): string {
    return this.res.svgUrl('ContextMenu-ObjectSets-Image');
  }
  get paste(): string {
    return this.res.get('ContextMenu-PasteValueFromClipboard');
  }
  get pasteImage(): string {
    return this.res.svgUrl('ContextMenu-PasteValueFromClipboard-Image');
  }
  get copy(): string {
    return this.res.get('ContextMenu-CopyColumnToClipboard');
  }
  get copyImage(): string {
    return this.res.svgUrl('ContextMenu-CopyColumnToClipboard-Image');
  }
  get excel(): string {
    return this.res.get('ContextMenu-ExportToExcel');
  }
  get excelImage(): string {
    return this.res.svgUrl('ContextMenu-ExportToExcel-Image');
  }
  get pdf(): string {
    return this.res.get('ContextMenu-ExportToPDF');
  }
  get pdfImage(): string {
    return this.res.svgUrl('ContextMenu-ExportToPDF-Image');
  }
  get more(): string {
    return this.res.get('ContextMenu-MoreOptions');
  }
  get moreImage(): string {
    return this.res.svgUrl('ContextMenu-MoreOptions-Image');
  }
  get resetLayout(): string {
    return this.res.get('ContextMenu-ResetLayout');
  }
  get resetLayoutImage(): string {
    return this.res.svgUrl('ContextMenu-ResetLayout-Image');
  }
  get group() {
    return {
      enableCaption: this.res.get('ContextMenu-GroupBy-Enable'),
      disableCaption: this.res.get('ContextMenu-GroupBy-Disable'),
      image: this.res.svgUrl('ContextMenu-GroupBy-Image'),
      name: gridOptions.groupable,
    };
  }
  get filterHeader() {
    return {
      enableCaption: this.res.get('ContextMenu-HeaderFilter-Enable'),
      disableCaption: this.res.get('ContextMenu-HeaderFilter-Disable'),
      image: this.res.svgUrl('ContextMenu-HeaderFilter-Image'),
      name: gridOptions.columnFilter,
    };
  }
  get filterBuilder() {
    return {
      enableCaption: this.res.get('ContextMenu-FilterBuilder-Enable'),
      disableCaption: this.res.get('ContextMenu-FilterBuilder-Disable'),
      image: this.res.svgUrl('ContextMenu-FilterBuilder-Image'),
      name: gridOptions.filterPanel,
    };
  }
  get filterRow() {
    return {
      enableCaption: this.res.get('ContextMenu-FilterRow-Enable'),
      disableCaption: this.res.get('ContextMenu-FilterRow-Disable'),
      image: this.res.svgUrl('ContextMenu-FilterRow-Image'),
      name: gridOptions.showfilterrow,
    };
  }
  get selectionMode() {
    return {
      enableCaption: this.res.get('ContextMenu-MultipleSelection'),
      disableCaption: this.res.get('ContextMenu-SingleSelection'),
      image: this.res.svgUrl('ContextMenu-MultipleSelection-Image'),
      name: gridOptions.selectionMode,
    };
  }
  get totalCount() {
    return {
      enableCaption: this.res.get('ContextMenu-TotalCount-Enable'),
      disableCaption: this.res.get('ContextMenu-TotalCount-Disable'),
      image: this.res.svgUrl('ContextMenu-TotalCount-Image'),
      name: gridOptions.summaryTotalCount,
    };
  }
  get totalSum() {
    return {
      enableCaption: this.res.get('ContextMenu-TotalSum-Enable'),
      disableCaption: this.res.get('ContextMenu-TotalSum-Disable'),
      image: this.res.svgUrl('ContextMenu-TotalSum-Image'),
      name: gridOptions.summaryTotalSum,
    };
  }
  get columnResizing() {
    return {
      enableCaption: this.res.get('ContextMenu-ColumnResizing-Enable'),
      disableCaption: this.res.get('ContextMenu-ColumnResizing-Disable'),
      image: this.group.image,
      name: gridOptions.columnResize,
    };
  }
  get columnHeaders() {
    return {
      enableCaption: this.res.get('ContextMenu-ColumnHeaders-Enable'),
      disableCaption: this.res.get('ContextMenu-ColumnHeaders-Disable'),
      image: this.columnselectionImage,
      name: gridOptions.columnHeaders,
    };
  }
}

export enum AbcGridColumnsLine {
  None = 'none',
  Line = '1px solid rgba(115, 140, 155, 0.6)',
}
